class Resource {

    constructor() {
        window.Nav.navOpacityChanger();
    }
}

export default Resource;
